<template>
  <transition name="c-loading">
  <div class="c-loading">
  </div>
  </transition>
</template>

<script>
  import { assets_path } from '@/_modules/utils/variables'
  import store from '@/_modules/stores';

  export default {
    data() {
      return {
        assets_path: assets_path
      }
    },
    store,
    mounted() {
    },
    methods: {
    }
  }
</script>
